export enum SHOW_PRESCHOOL {
  Yes = 1,
  No = 0
}